import React from 'react';

import BenchlingProfiler, {logProfilerTimingEvent} from 'performance/BenchlingProfiler';
import {toDatadogTagFormat} from 'performance/PerformanceUtils';
import {CONTENT_RENDER_FINISHED_EVENT, CONTENT_RENDER_STARTED_EVENT} from 'performance/processNotebookEvents';

import {VirtualizationState} from './VirtualizationState';

export interface VirtualizableProps {
  eventId: string;
  contentType: string;
  documentType: string;
  virtualizationState: VirtualizationState;
  renderVirtualizedSkeleton: () => JSX.Element;
  renderDevirtualizedItem: () => JSX.Element;
}

export default ({
  eventId,
  contentType,
  documentType,
  virtualizationState,
  renderVirtualizedSkeleton,
  renderDevirtualizedItem,
}: VirtualizableProps): JSX.Element => {
  const shouldVirtualize = virtualizationState !== VirtualizationState.DEVIRTUALIZED;
  const extra: Record<string, unknown> = {
    distributionMetadata: {
      content_type: toDatadogTagFormat(contentType),
      document_type: toDatadogTagFormat(documentType),
      virtualization_state: toDatadogTagFormat(shouldVirtualize ? 'virtualized' : 'devirtualized'),
    },
  };
  logProfilerTimingEvent({...CONTENT_RENDER_STARTED_EVENT, id: eventId}, extra);
  return (
    <BenchlingProfiler {...CONTENT_RENDER_FINISHED_EVENT} id={eventId} extra={extra}>
      {shouldVirtualize ? renderVirtualizedSkeleton() : renderDevirtualizedItem()}
    </BenchlingProfiler>
  );
};
